import { useEffect, useState } from 'react';
import axios from 'axios';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import IconChat from '../../components/icons/IconChat';

const SEVERITY_OPTIONS = [
  { id: '', label: 'Всі' },
  { id: 'ERROR', label: 'Помилки' },
  { id: 'WARNING', label: 'Попередження' },
];

function formatDate(value) {
  if (!value) return '';
  const dt = DateTime.fromISO(value, { setZone: true });
  return dt.isValid ? dt.toFormat('dd.MM.yyyy HH:mm') : value;
}

export default function BotErrorsPanel() {
  const navigate = useNavigate();
  const [severity, setSeverity] = useState('');
  const [viewMode, setViewMode] = useState('recent');
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState('loading');
  const [navigatingId, setNavigatingId] = useState(null);

  useEffect(() => {
    setStatus('loading');
    const base = viewMode === 'recent' ? '/api/bot-errors' : '/api/bot-errors/summary';
    const url = base + (severity ? '?severity=' + severity : '');
    axios.get(url, { withCredentials: true })
      .then(response => { setRows(response.data || []); setStatus('done'); })
      .catch(() => setStatus('error'));
  }, [severity, viewMode]);

  function goToConversation(row) {
    setNavigatingId(row.id);
    axios.get('/api/bot-errors/' + row.id + '/conversation-progress', { withCredentials: true })
      .then(response => navigate('/messages/byconvprogress/' + response.data.conversationProgressId))
      .catch(() => alert('Не вдалося знайти розмову для цієї помилки'))
      .finally(() => setNavigatingId(null));
  }

  return (
    <div className="conv-dashboard-section">
      <div className="conv-dashboard-section-header">
        <h4 className="conv-dashboard-section-title">Помилки бота</h4>
        <div className="bot-errors-controls">
          <div className="bot-errors-toggle">
            <span className={viewMode === 'recent' ? 'active' : ''} onClick={() => setViewMode('recent')}>Останні</span>
            <span className={viewMode === 'aggregated' ? 'active' : ''} onClick={() => setViewMode('aggregated')}>Згруповані</span>
          </div>
          <select className="bot-errors-severity-select" value={severity} onChange={e => setSeverity(e.target.value)}>
            {SEVERITY_OPTIONS.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
          </select>
        </div>
      </div>

      {status === 'loading' ? <p className="conv-dashboard-empty">Завантаження...</p> : ''}
      {status === 'error' ? <p className="conv-dashboard-empty">Не вдалося завантажити</p> : ''}
      {status === 'done' && rows.length === 0 ? <p className="conv-dashboard-empty">Помилок не знайдено</p> : ''}

      {status === 'done' && rows.length > 0 ? (
        <ul className="bot-errors-list">
          {rows.map((row, index) => (
            <li className="bot-errors-row" key={row.id || index}>
              <span className={'bot-error-severity ' + (row.severity === 'WARNING' ? 'warning' : 'error')}>
                {row.severity === 'WARNING' ? 'Попередження' : 'Помилка'}
              </span>
              <div className="bot-errors-main">
                <div className="bot-errors-op-msg">
                  <b>{row.operation}</b> — {row.errorMessage}
                </div>
                <div className="bot-errors-meta">
                  {row.recipientName ? <span>Кому: {row.recipientName}</span> : ''}
                  {row.conversationName ? <span>Тест: {row.conversationName}</span> : ''}
                  {row.answerText ? <span>Питання: {row.answerText}</span> : ''}
                </div>
              </div>
              {viewMode === 'aggregated' ? (
                <div className="bot-errors-count">
                  <span className="bot-errors-count-badge">×{row.occurrenceCount}</span>
                  <span className="bot-errors-time">{formatDate(row.lastOccurredAt)}</span>
                </div>
              ) : (
                <div className="bot-errors-actions">
                  {row.conversationId && row.outerUserId ? (
                    <div
                      className="bot-errors-goto"
                      title="Перейти до розмови з користувачем"
                      onClick={() => navigatingId === null && goToConversation(row)}
                    >
                      <IconChat fillColor={navigatingId === row.id ? 'icon-contrast' : 'icon-blue'} style={{ height: 18, width: 18 }} />
                    </div>
                  ) : ''}
                  <span className="bot-errors-time">{formatDate(row.dAdd)}</span>
                </div>
              )}
            </li>
          ))}
        </ul>
      ) : ''}
    </div>
  );
}
